import React from "react";
import { ModeRendererProps } from "./types";

export function CheckerMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <rect x="0" y="0" width="794" height="1123" fill="url(#checker)" />
      <g transform="translate(397 540)">
        {Array.from({ length: 16 }).map((_, i) => {
          const rr = 60 + i * 22;
          const op = 0.1 + (15 - i) * 0.04;
          const col = i % 3 === 0 ? brand.aqua : i % 3 === 1 ? brand.violet : brand.amber;
          return <circle key={i} r={rr} fill="none" stroke={col} strokeWidth={i % 2 ? 2.0 : 1.2} opacity={Math.max(0.06, op)} />;
        })}
        <circle r="80" fill={brand.deep} opacity="0.5" />
      </g>
    </g>
  );
}
